
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { retrieveDisclosureShow } from "../../Services/DisclosureApiService";
import LogoHeader from "../../Components/PrimeReact/logoBanner";
import { useAuthHeader } from "../../auth/AuthService";

export default function DisclosureDetail() {
    const {id} = useParams();
    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();

    const [disclosure, setDisclosure] = useState();
    const [disclosures, setDisclosures] = useState([]);

    async function getData() {
        await retrieveDisclosureShow(id, authHeader())
        .then((response) => {
            let data = response.data.data;
            if (data.length > 0) {
                setDisclosure(data[0]);
                setDisclosures(data);
            }
        })
        .catch((error) => console.log(error));
    }

    useEffect(() => {
        getData();
    }, [id, i18n.language]);

    return (
        <>
            <LogoHeader />
            
            <div className="col-12 text-4xl font-bold">{t('Disclosure & Notice')}</div>
            <div className='col-12 mb-4'>
                <div className="card p-3 shadow-6 border-round-2xl bg-card">
                    <div className='grid align-items-center'>
                        <div className="col-4 md:col-2 pl-4">
                            <p>{t('Date')}</p>
                            <p>{t('Issue Name')}</p>
                            <p>{t('Issue Code')}</p>
                            <p>{t('Disclosure Type')}</p>
                            <p>{t('Title')}</p>
                        </div>
                        <div className="col-8 md:col-10">
                            <p>: {disclosure && disclosure.tdate} </p>
                            <p>: </p>
                            <p>: {disclosure && disclosure.icode} </p>
                            <p>:  </p>
                            <p>: {disclosure && disclosure.dtdcontents} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 text-4xl font-bold">{t('Detail Content')}</div>
            <div className="col-12">
                <pre className="dis-content shadow-6 border-round-2xl p-4">
                    { disclosures.map((v) => v.dtdcontents) }
                </pre>
            </div>
        </>
    );
}